// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1I_FJ","icon":"styles_icon__1ghTk"};